export { default } from "./empty-star";
